import React, { useState } from "react";
import { FilterSearchIcon, HidePassword, ShowPassword, XIcon } from "../../../assets/images/svg";

export function Input({
  value,
  onChange,
  label,
  customProps = {},
  leftIcon,
  className = "",
  renderRightIcon,
  inputType = "text",
  htmlFor,
  autoComplete = "off",
  placeholder = ""
}) {
  const inputClassName = "input__field" + (className ? " " + className : "");
  const id = label ? { id: htmlFor } : {};
  return (
    <div className="input">
      {label && (
        <label className="input__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}

      <div className="input__control">
        <input
          {...id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type={inputType}
          placeholder={placeholder}
          {...customProps}
          className={inputClassName}
          autoComplete={autoComplete}
        />

        {leftIcon && (
          <div className="input__icon input__icon--left" data-testid="icon-left">
            {leftIcon}
          </div>
        )}

        {renderRightIcon && renderRightIcon()}
      </div>
    </div>
  );
}

export const SearchInput = (props) => (
  <Input
    {...props}
    className="input__field--search"
    leftIcon={<FilterSearchIcon />}
    renderRightIcon={() =>
      props.value && (
        <div
          className="input__icon input__icon--right"
          data-testid="icon-right"
          onClick={props.onClear}
        >
          <XIcon />
        </div>
      )
    }
  />
);

export const PasswordInput = (props) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);

  return (
    <Input
      {...props}
      inputType={passwordVisibility ? "text" : "password"}
      renderRightIcon={() => (
        <div
          className="input__icon input__icon--right"
          data-testid="icon-right"
          onClick={() => setPasswordVisibility(!passwordVisibility)}
        >
          {passwordVisibility ? <HidePassword /> : <ShowPassword />}
        </div>
      )}
    />
  );
};
